






























import { TypeHeading, TypeDisplay, SelectInput } from '@bambeehr/pollen';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'EmployeeSelect',
  components: {
    TypeHeading,
    TypeDisplay,
    SelectInput,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    currentOption: {
      type: String,
      required: true,
    },
  },
  setup(_, { emit }) {
    const handleInput = (event: any) => {
      if (event) {
        emit('handleTabChange', event);
      }
    };

    return {
      handleInput,
    };
  },
});
